import { Table, Button, TableSelectionEvent, ClickEvent, Layout, SlideoutDecorator } from "@mcleod/components";
import { Alignment, DateRange, DisplayType, DisplayValue, ModelRow, Navigation } from "@mcleod/core";
import { LaneHistory } from "@mcleod/dispatch";
import { AutogenLayoutCarrierSalesToolPanel } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesToolPanel";
import { CarrierSalesBoard } from "./CarrierSalesBoard";
import { AvailableLoadsList } from "./AvailableLoadsList";

export class CarrierSalesToolPanel extends AutogenLayoutCarrierSalesToolPanel {
    table: Table;
    public isContractManagementActive: boolean;

    override async onLoad(): Promise<void> {
        this.addMountListener(() => this.initialize(this.owner));
    }

    initialize(layout?: CarrierSalesBoard) {
        this.table = this.table ?? layout?.tableCarrierSalesActions;
    }

    tableCarrierSalesOnSelect(event: TableSelectionEvent) {
        const tableRow = event.newRow;
        const validRow = !!tableRow;
        this.buttonCapacity.enabled = 
        this.buttonLaneHistory.enabled = 
        this.buttonAvailableLoads.enabled = validRow;
    }

    /** This is an event handler for the onClick event of buttonLoadboard. */
    buttonCapacityOnClick() {
        const selected = this.table.selectedRow;
        if (selected == null) return;
        
        const path = `lme/powerbroker/CarrierCapacity?carrier=${selected.data.getString("carrier_id")}`
        Navigation.navigateTo(path, { newTab: true, height: 1400, width: 1850, windowDecorators: false });
    }

    /** This is an event handler for the onClick event of buttonLaneHistory. */
    buttonLaneHistoryOnClick(event: ClickEvent) {
        const data = this.table?.selectedRow?.data;
        if (data == null) return;

        const button = event.target as Button;
        button.busy = true;
        const laneHistoryLayout: LaneHistory = Layout.getLayout("lme/dispatch/LaneHistory") as LaneHistory;
        laneHistoryLayout.addLoadErrorListener(() => button.busy = false);

        new SlideoutDecorator({
            layout: laneHistoryLayout,
            layoutLoadListeners: async () => {
                laneHistoryLayout.layoutheaderLaneHist.visible = false;
                const lmData = new ModelRow(laneHistoryLayout.textboxOverridePayeeId.lookupModel, false,
                    {
                        id: data.getString("carrier_id"),
                        name: data.getString("carrier_name")
                    });

                laneHistoryLayout.mainDataSource.searchRow.setValueAndLookupModelData("override_payee_id", data.getString("carrier_id"), lmData);
                laneHistoryLayout.textboxOverridePayeeId.displayData(laneHistoryLayout.mainDataSource.searchRow, null, 0);
                laneHistoryLayout.payeeSelection(data.getString("carrier_id"));

                const defaultDateRange = DateRange.parseDateRangeWithKeywords("t-30,t");
                laneHistoryLayout.textboxDateRange.text = DisplayValue.getDisplayValue(defaultDateRange, DisplayType.DATERANGE, laneHistoryLayout.textboxDateRange.format);
                laneHistoryLayout.sourceLaneHistory.executeValidatedSearch();
            },
            fillVerticalSpace: true,
            fillHorizontalSpace: true,
            title: "Lane History",
            transitionOptions: { direction: Alignment.CENTER },
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            doAfterSlideIn: () => button.busy = false
        });
    }

    buttonAvailableLoadsOnClick(event: ClickEvent) {
        const data = this.table?.selectedRow?.data;
        if (data == null) return;

        const button = event.target as Button;
        button.busy = true;

        const layout = Layout.getLayout("lme/crm/AvailableLoadsList") as AvailableLoadsList;
        layout.addLayoutLoadListener(() => {
            layout.carrierId = data.getString("carrier_id");
            layout.textboxDefaultContact.text = data.getString("contact", null);
            layout.textboxPhone.text = data.getString("contact_phone", null);
            layout.textboxEmail.text = data.getString("contact_email", null);
        });

        new SlideoutDecorator({
            layout: layout,
            fillVerticalSpace: true,
            fillHorizontalSpace: true,
            transitionOptions: { direction: Alignment.BOTTOM },
            title: "Available Loads"
        });

        button.busy = false;
    }
}